import classes from '../styles/Page.module.scss';
import client from './api/graphql';
import { GET_GETTING_STARTED_CONTENT } from './api/graphql/queries';
import PageHeader from '../components/organisms/pageHeader/PageHeader';
import GettingStartedSteps from '../components/sections/gettingStartedSteps/GettingStartedSteps';
import VideoTutorial from '../components/sections/videoTutorial/VideoTutorial';
import Subfooter from '../components/organisms/subfooter/Subfooter';
import { redirectedPtAndArToEnglish } from '../utils/functions';

/**
 * Ayoba Web Getting Started Page
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const GettingStarted = (props) => {
    /**
     * Section content
     */
    const { gettingStarted, landingPages } = props?.data;
    const { page_details, getting_started_steps, tutorial_video } =
        gettingStarted?.data?.attributes;

    return (
        <div className={classes.oPageGettingStarted}>
            <PageHeader {...page_details} />
            <GettingStartedSteps
                className={classes.oGettingStartedSteps}
                data={getting_started_steps}
            />
            <VideoTutorial data={tutorial_video} />
            <Subfooter {...landingPages} />
        </div>
    );
};

export async function getServerSideProps(context) {
    let locale = context.query?.lang || context.defaultLocale;
    locale = redirectedPtAndArToEnglish(locale)

    const { data } = await client.query({
        query: GET_GETTING_STARTED_CONTENT,
        variables: { _locale: locale }
    });

    return {
        props: { data }
    };
}

export default GettingStarted;
